export const SET_MENU = "SET_MENU";
export const SW_INIT = "SW_INIT";
export const SW_UPDATE = "SW_UPDATE";
export const SET_ERRORS = "SET_ERRORS";
export const SET_TRIGGER_TABLE = "SET_TRIGGER_TABLE";
export const SET_FROM_LOGIN = "SET_FROM_LOGIN";
export const SET_LOADING = "SET_LOADING";
export const SET_TABLE_DATA = "SET_TABLE_DATA";
